export function formatNumber(n: number): string {
  if (n >= 1e9) return (n / 1e9).toFixed(1) + 'B';
  if (n >= 1e6) return (n / 1e6).toFixed(1) + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(1) + 'K';
  return Math.floor(n).toString();
}

export function formatCostShort(cost: Record<string, number>): string {
  const labels: Record<string, string> = { gold: 'Au', food: 'Fd', faith: 'Ft', knowledge: 'Kn' };
  const parts: string[] = [];
  for (const [key, val] of Object.entries(cost)) {
    if (val > 0) parts.push(`${labels[key] ?? key}:${formatNumber(val)}`);
  }
  return parts.join(' ');
}
